<template>
  <div class="row filter-row">
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus position-relative">
        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
          style="z-index: 100; font-size: 12px;">Start Date</label>
        <div class="cal-icon" style="z-index: 90;">
          <date-picker v-model="startDate" placeholder="Start Date" class="form-control floating datetimepicker"
            :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="loadClick" />
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus position-relative">
        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
          style="z-index: 100; font-size: 12px;">End Date</label>
        <div class="cal-icon" style="z-index: 90;">
          <date-picker v-model="endDate" placeholder="End Date" class="form-control floating datetimepicker"
            :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="loadClick" />
        </div>
      </div>
    </div>

    <div class="col-sm-6 col-md-3">
      <a href="javascript:;" class="btn btn-secondary mb-3 btn-sm w-100 me-2" data-bs-toggle="modal"
        data-bs-target="#select_banked_user_modal">Filters</a>
    </div>
  </div>
  <filter-activity-user-modal @onUsersSelected="selectedUsers" :initialType="initialType" :initialUsers="initialUsers"></filter-activity-user-modal>
</template>

<script>
import { formatDateForApi } from '@/utils/util-funcitons';

export default {
  props: {
    getSelectedValues: {
      type: Function
    },
    initialType: {
      type: String,
      default: ''
    },
    initialUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      startDate: new Date(),
      endDate: new Date(new Date().getFullYear(), 11, 31),
      filterdUsers: [],
      dateFormat: 'dd/MM/yyyy'
    };
  },
  mounted() {
  },
  methods: {
    selectedUsers(value) {
      this.filterdUsers = value;
      this.loadClick();
    },

    loadClick() {
      let date = {
        start_date: formatDateForApi(this.startDate),
        end_date: formatDateForApi(this.endDate),
      };

      this.getSelectedValues(this.filterdUsers, date);
    }
  }
};
</script>
